/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 📄 File: i18n/index.ts
 🧩 Description:
    i18next initialization with react-i18next.
    Translation resources → i18nResources.ts (imports + object).
────────────────────────────────────────────────────────────────*/

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nResources, i18nNamespaces } from './i18nResources';

export const availableLanguages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
];

const savedLanguage =
    typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') || 'en' : 'en';

i18n
    .use(initReactI18next)
    .init({
        lng: savedLanguage,
        fallbackLng: 'en',
        debug: false,
        load: 'currentOnly',
        resources: i18nResources,
        defaultNS: 'common',
        ns: i18nNamespaces,
        fallbackNS: ['common'],
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
    });

export const changeLanguage = (locale: string) => i18n.changeLanguage(locale);
export const getCurrentLanguage = () => i18n.language;
export const getAvailableLanguages = () => availableLanguages;

export default i18n;
